import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import styles from "../Home.module.css";
const forces = [{
  stat: "15%",
  colorClass: "text-chart-1",
  // sky blue
  description: "Projected contraction in the traditional 18-year-old pool"
}, {
  stat: "1 in 3",
  colorClass: "text-chart-2",
  // warm amber
  description: "Adult learners lost before completion without redesigned supports"
}, {
  stat: "43%",
  colorClass: "text-chart-3",
  // coral
  description: "Of transfer students lose credits in the handoff"
}];
export default function ThreeForces() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section className={`bg-background py-20 lg:py-28 ${styles.homeGridBackground}`}>
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        <div ref={ref} className={`flex flex-col items-center text-center transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          {/* Centered H2 */}
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-foreground max-w-3xl mb-16">
            Three forces reshaping higher education
          </h2>

          {/* Three large stats */}
          <div className="w-full grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-16 mb-14">
            {forces.map((item, index) => <div key={index} className="flex flex-col items-center text-center px-4">
                <span className={`text-6xl sm:text-7xl lg:text-8xl font-extrabold tracking-tight mb-4 ${item.colorClass}`}>
                  {item.stat}
                </span>
                <p className="text-foreground font-medium text-lg lg:text-xl max-w-xs leading-snug">
                  {item.description}
                </p>
              </div>)}
          </div>

          {/* Footnote */}
          <p className="text-sm text-muted-foreground font-medium">
            Directional figures — validated against your data in discovery.
          </p>
        </div>
      </div>
    </section>;
}